import React, { useEffect, useState } from 'react';
import { Modal, Box, ClickAwayListener, Tooltip, useMediaQuery } from '@mui/material';
import img1 from '../../../assets/offersforyou1.png';
import CloseIcon from '../../../assets/svg/closeIcon';
import starPic from '../../../assets/StarWhite.svg';
import './OfferDetailsModal.css';
import { useTranslation } from 'react-i18next';
import { getOpenStatusFromAPI } from '../../../OpenStatus';

const OfferDetailsModal = ({ 
    vendorName,open = false, 
    handleClose = () => {}, 
    offer, handleOrderClick = () => {}, 
    showOrderButton = false, 
    paddingBottom, 
    vendorId ,
    vendorDistance
}) => {
    const address = offer?.vendor?.Address
        ? `${offer?.vendor?.Address}, ${[
            offer?.vendor?.city,
            offer?.vendor?.state,
            offer?.vendor?.country,
            offer?.vendor?.pincode
        ]
            .filter(Boolean)
            .join(', ')}`
        : '';

    const { t } = useTranslation();
    const [pickupTooltipOpen, setPickupTooltipOpen] = useState(false);
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);
    const [vendorStatus, setVendorStatus] = useState(false);
    const [vendorOpeningTime, setVendorOpeningTime] = useState();
    const [vendorOpeningDay, setVendorOpeningDay] = useState();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const handleTooltipOpen = () => {
        if (vendorStatus !== 'open') {
            setTooltipOpen(true);
            setTimeout(() => {
                setTooltipOpen(false);
            }, 3000);
        }
    };
    
    const handleTooltipClose = () => {
        setTooltipOpen(false);
    };
    
    const checkStatus = () => {
        getOpenStatusFromAPI(vendorId)
            .then((data) => {
                setVendorStatus(data.status);
                setVendorOpeningTime(data.nextOpenTime);
                setVendorOpeningDay(data.nextOpenDay);
            })
            .catch((error) => {
                console.error('Error checking status:', error);
            });
    };
   
    useEffect(() => {
        checkStatus();
    }, []);

    setTimeout(() => {
        setAnimateModal(true);
    }, 100);

    function getDate(isoString) {
        return new Date(isoString).toISOString().split('T')[0];
    }

    return (
        <Modal
            open={open}
            onClose={() => {
                setClosing(true);
                handleClose();
            }}
            style={{
                backdropFilter: 'blur(10px)',
                backgroundColor: '#2C3142B2 !important',
            }}
        >
            <Box
                className={`offer-detail-popup ${animateModal ? 'animate' : ''} ${
                    closing ? 'close' : ''
                }`}
            >
                <div className='offer-image-container11'>
                    <div className='offer-img'>
                        <div className='image-overlay'>
                            <img
                                src={offer?.Avatar_key || img1}
                                alt={offer?.vendor?.Name}
                                onError={(e) => {
                                    e.target.src = img1;
                                }}
                                className='image'
                            />
                        </div>
                    </div>
                    <div className='title-close-container'>
                        <CloseIcon
                            size={30}
                            color='white'
                            onClick={handleClose}
                            className='close-icon'
                        />
                    </div>
                    <div className='menu-item-offer-container'>
                        <p className='menu-item1'>{offer?.vendor?.Name}</p>
                        <p className='item-offer1'>{offer?.percentage}%off</p>
                    </div>
                    <div className='img-rating-restaurant'>
                        <p className='rating-order'>
                            {offer?.vendor?.avg_rating == 'N/A'
                                ? '0.0'
                                : Number(offer?.vendor?.avg_rating || 0.0)?.toFixed(1)}
                        </p>
                        <img className='star-img-order' src={starPic} alt='star' />
                    </div>
                </div>

                <div className='offer-details-container' style={{paddingBottom: paddingBottom, marginBottom: !showOrderButton ? '20px' : '0px'}}>
                    <div className='address-container11'>
                        <div className='info-container2'>
                            <p className='info-text2'>{t('offersDetails.Address')}</p>
                            <span className='two-dot2'>:</span>
                            <p className='info-value2'>{address}</p>
                        </div>
                        {offer?.valid_from && (
                            <div className='info-container2'>
                                <p className='info-text2'>{t('offersDetails.Valid_From')}</p>
                                <span className='two-dot2'>:</span>
                                <p className='info-value2'>{getDate(offer?.valid_from)}</p>
                            </div>
                        )}
                        {offer?.valid_to && (
                            <div className='info-container2'>
                                <p className='info-text2'>{t('offersDetails.Valid_To')}</p>
                                <span className='two-dot2'>:</span>
                                <p className='info-value2'>{getDate(offer?.valid_to)}</p>
                            </div>
                        )}
                    </div>
                    <div className='break-line2'></div>
                    <div className='description-container'>
                        <div className='info-container22'>
                            <p className='info-text22'>
                                {t('offersDetails.Short_Description')} :
                            </p>
                            <p className='info-value22'>{offer?.shortdescription}</p>
                        </div>
                        <div className='info-container22'>
                            <p className='info-text22'>{t('offersDetails.Description')} :</p>
                            <p className='info-value22'>{offer?.Description}</p>
                        </div>
                    </div>
                    <div className='break-line22'></div>
                    <div className='limit-amount-container'>
                        <div className='info-container12'>
                            <p className='info-text12'>
                                {t('offersDetails.Maximum_Amount')} :
                            </p>
                            <p className='info-value12'>{offer?.Max_amount || 0}</p>
                        </div>
                        <div className='info-container12'>
                            <p className='info-text12'>{t('offersDetails.Redeem_Limit')} :</p>
                            <p className='info-value12'>{offer?.Offer_redemlimit || 0}</p>
                        </div>
                    </div>
                </div>
                {showOrderButton && (
                    isMobile && vendorStatus !== 'open' ? (
                        <ClickAwayListener onClickAway={handleTooltipClose}>
                            <Tooltip
                                onClose={handleTooltipClose}
                                open={tooltipOpen}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                title={`Oops! ${vendorName} is taking a break. They’ll be back ${(vendorOpeningTime && vendorOpeningDay) ? `at ${vendorOpeningDay} ${vendorOpeningTime}` : 'soon'}.`}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: '#E13535',
                                            color: '#ffffff',
                                            fontSize: '16px',
                                            lineHeight: '20px',
                                            borderRadius: '6px',
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: '#E13535',
                                        },
                                    },
                                }}
                                arrow
                            >
                                <div className="order-button-container">
                                    <button
                                        className="order-popup-btn"
                                        onClick={handleTooltipOpen}
                                    >
                        Order
                                    </button>
                                </div>
                            </Tooltip>
                        </ClickAwayListener>
                    ) : isMobile && vendorStatus === 'open' && vendorDistance > 20 ? (
                        <ClickAwayListener onClickAway={() => setPickupTooltipOpen(false)}>
                            <Tooltip
                                onClose={() => setPickupTooltipOpen(false)}
                                open={pickupTooltipOpen}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                title="Only pickup available."
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: '#E13535',
                                            color: '#ffffff',
                                            fontSize: '16px',
                                            lineHeight: '20px',
                                            borderRadius: '6px',
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: '#E13535',
                                        },
                                    },
                                }}
                                arrow
                            >
                                <div className="order-button-container">
                                    <button
                                        className="order-popup-btn"
                                        onClick={() => {
                                            setPickupTooltipOpen(true);
                                            setTimeout(() => {
                                                setPickupTooltipOpen(false);
                                            }, 2000);
                                            setTimeout(() => {
                                                handleOrderClick(vendorName);
                                            }, 1000);
                                        }}
                                    >
                                            Order
                                    </button>
                                </div>
                            </Tooltip>
                        </ClickAwayListener>
                    ) : vendorStatus === 'open' && vendorDistance > 20 ? (
                        <Tooltip
                            title="Only pickup available."
                            arrow
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#E13535',
                                        color: '#ffffff',
                                        fontSize: '16px',
                                        lineHeight: '20px',
                                        borderRadius: '6px',
                                    },
                                },
                                arrow: {
                                    sx: {
                                        color: '#E13535',
                                    },
                                },
                            }}
                        >
                            <div className="order-button-container">
                                <button
                                    className="order-popup-btn"
                                    onClick={() => handleOrderClick(vendorName)}
                                >
                    Order
                                </button>
                            </div>
                        </Tooltip>
                    ) : vendorStatus === 'open' ? (
                        <div className="order-button-container">
                            <button
                                className="order-popup-btn"
                                onClick={() => handleOrderClick(vendorName)}
                            >
                Order
                            </button>
                        </div>
                    ) : (
                        <Tooltip
                            title={`Oops! ${offer?.vendor?.Name || vendorName} is taking a break. They’ll be back ${(vendorOpeningTime && vendorOpeningDay) ? `at ${vendorOpeningDay} ${vendorOpeningTime}` : 'soon'}.`}
                            arrow
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#E13535',
                                        color: '#ffffff',
                                        fontSize: '16px',
                                        lineHeight: '20px',
                                        borderRadius: '6px',
                                    },
                                },
                                arrow: {
                                    sx: {
                                        color: '#E13535',
                                    },
                                },
                            }}
                        >
                            <div className="order-button-container">
                                <button
                                    className="order-popup-btn"
                                    disabled
                                >
                    Order
                                </button>
                            </div>
                        </Tooltip>
                    )
                )}

            </Box>
        </Modal>
    );
};

export default OfferDetailsModal;
